module.exports = __webpack_public_path__ + "static/media/SC400.4e3da3ad.png";